<template>
	<div class="page flex-column">
		<div class="logo">
			<img src="@/assets/image/login_logo.png" alt="">
		</div>
		<div class="body flex-grow flex-between-center">
			<div class="banner flex-center">
				<img src="@/assets/image/login_image.png" alt="">
				<div class="slogan">
					<p v-for="(item, i) in slogan" :key="i" :style="{'opacity': switchSloganIndex == i ? 0 : 1}">{{item}}</p>
				</div>
			</div>
			<div class="login">
				<h1 class="title">欢迎登录机老大管家</h1>
				<c-tab-list ref="tabList" class="tabs" :tabs="typeList" @change="data => type = data.value"></c-tab-list>

				<c-form v-show="type == 1" ref="phoneLogin" class="form">
					<c-input v-model="phone" class="item" type="text" name="phone" placeholder="请输入手机号" :clear="false" @enter="login">
						<template #prependIcon>
							<i class="item-icon tf-phone tf-fw"></i>
						</template>
					</c-input>
					<c-input class="item" type="text" name="verify_code" placeholder="短信验证码" :clear="false" maxlength="4" @enter="login">
						<template #prependIcon>
							<i class="item-icon tf-smscode tf-fw"></i>
						</template>
						<template #append>
							<a class="smscode" :class="{'z-dis': !!countdown}" @click="getSmscode">{{countdownText}}</a>
						</template>
					</c-input>
				</c-form>

				<c-form v-show="type == 2" ref="userLogin" class="form">
					<c-input class="item" type="text" name="saas_name" placeholder="请输入店铺/公司代码" :clear="false" @enter="login">
						<template #prependIcon>
							<i class="item-icon tf-company tf-fw"></i>
						</template>
					</c-input>
					<c-input class="item" type="text" name="user_name" placeholder="请输入用户名" :clear="false" @enter="login">
						<template #prependIcon>
							<i class="item-icon tf-username tf-fw"></i>
						</template>
					</c-input>
					<c-input class="item" type="password" name="user_pwd" placeholder="请输入密码" :clear="false" visible @enter="login">
						<template #prependIcon>
							<i class="item-icon tf-password tf-fw"></i>
						</template>
					</c-input>
				</c-form>
				<c-checkbox v-model="agreementState">
					<span class="agreement">我已阅读并同意<a @click.stop="agreementHandle(2)">《平台服务协议》</a><a @click.stop="agreementHandle(1)">《隐私协议》</a></span>
				</c-checkbox>
				<c-button class="button" size="form" color="main" @click="login">登录</c-button>
			</div>
		</div>

		<div class="foot-box">
			<div class="foot flex-between-center">
				<div class="copyright">
					<p>{{publicConfig ? publicConfig.platform_copyright_info : '-'}}</p>
					<p>
						<a href="https://beian.miit.gov.cn/" target="_blank">{{publicConfig ? publicConfig.platform_icp_record_no : '-'}}</a>
						<ins>|</ins>
						<img src="@/assets/image/beian.png"><a :href="publicConfig ? publicConfig.platform_public_security_record_url : ''" target="_blank">{{publicConfig ? publicConfig.platform_public_security_record_no : '-'}}</a>
						<ins>|</ins>
						<a v-if="publicConfig && publicConfig.platform_telecom_license_image" :href="publicConfig.platform_telecom_license_image" target="_blank">{{publicConfig ? publicConfig.platform_telecom_license_name : '-'}}</a>
					</p>
				</div>
				<div class="flex">
					<div v-if="publicConfig && publicConfig.platform_official_website_url" class="link flex-center"><i class="tf">&#xe672;</i><a :href="publicConfig.platform_official_website_url" target="_blank"></a></div>
					<div v-if="publicConfig && publicConfig.platform_wechat_qrcode_url" class="link flex-center" @click="$refs.office.open();"><i class="tf">&#xe8bb;</i></div>
					<div v-if="publicConfig && publicConfig.platform_mini_program_qrcode_url" class="link flex-center" @click="$refs.miniprogram.open()"><i class="tf">&#xe6ad;</i></div>
					<div v-if="publicConfig && publicConfig.platform_service_qrcode_url" class="link flex-center" @click="$refs.businessService.open()"><i class="tf">&#xe71b;</i></div>
				</div>
			</div>
		</div>

		<c-dialog ref="factoryList" width="600" :title="false" :close-button="false" :button="false">
			<dl class="factory-list">
				<dt>请选择商家</dt>
				<dd>
					<ul>
						<li v-for="(item, i) in factoryList" :key="i" class="flex-center" @click="factoryHandle(item)">
							<i class="icon tf-company"></i>
							<p class="flex-grow ellipsis">{{item.saas_name}}</p>
						</li>
					</ul>
				</dd>
			</dl>
		</c-dialog>

		<c-dialog ref="agreement1" title="隐私协议" width="800" height="600" :button="false">
			<div v-html="agreement[1]" class="agreement-content"></div>
		</c-dialog>

		<c-dialog ref="agreement2" title="平台服务协议" width="800" height="600" :button="false">
			<div v-html="agreement[2]" class="agreement-content"></div>
		</c-dialog>

		<c-dialog v-if="publicConfig" ref="businessService" width="400" :title="false" :button="false" mask-close>
			<div class="custom-service flex-column flex-center">
				<i class="tf icon">&#xe61d;</i>
				<h1>机老大管家官方客服</h1>
				<h2>专业二手回收 ERP，收、检、存、销、财，一站式管理系统，一机一码溯源，回收做账两不误;</h2>
				<img :src="publicConfig.platform_service_qrcode_url" alt="">
				<p>微信扫一扫咨询</p>
				<div class="tel flex-center">
					<i class="tf">&#xe679;</i>
					<b>{{publicConfig.platform_service_phone}}</b>
				</div>
			</div>
		</c-dialog>

		<c-dialog v-if="publicConfig" ref="office" width="300" :title="false" :button="false" mask-close>
			<div class="qrcode flex-column flex-center">
				<h1>机老大管家服务号</h1>
				<img :src="publicConfig.platform_wechat_qrcode_url" alt="">
				<p>微信扫一扫</p>
			</div>
		</c-dialog>

		<c-dialog v-if="publicConfig" ref="miniprogram" width="300" :title="false" :button="false" mask-close>
			<div class="qrcode flex-column flex-center">
				<h1>机老大管家小程序</h1>
				<img :src="publicConfig.platform_mini_program_qrcode_url" alt="">
				<p>微信扫一扫</p>
			</div>
		</c-dialog>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import {cryptoJs} from '@deanwu/vue-component-library'

	const sloganList = [
		'管货 管钱 管客源',
		'采购侠、转转快速估价',
		'实时竞拍（鱼市、采货侠、闪云拍）',
		'收、检、存、销、财',
		'10+平台一键同售',
		'一机一码溯源，回收做账两不误',
		'管好每台回收机，算清每笔到手利',
		'批量入库多平台同步，出货效率翻倍',
		'收机快、盘库快、对账快'
	]
	
	export default {
		props: {
			redirect: {
				type: String,
				default: '/'
			}
		},

		data() {
			return {
				slogan: [],
				switchSloganIndex: -1,

				typeList: [{
					name: '手机号登录',
					value: 1
				}, {
					name: '账号登录',
					value: 2
				}],
				type: 1,
				phone: '',
				countdown: false,
				
				factoryList: [],
				agreement: {},
				agreementState: false
			}
		},

		computed: {
			...mapState(['publicConfig']),

			countdownText() {
				return this.countdown ? `${this.countdown}s后重新获取` : this.countdown === 0 ? '重新获取' : '获取验证码';
			}
		},

		mounted() {
			let indexs = [];
			!function loop() {
				let i = Math.floor(Math.random() * sloganList.length);
				if (!indexs.includes(i)) indexs.push(i);
				if (indexs.length < 5) loop();
			}();
			this.slogan = indexs.map(i => sloganList[i]);
			this.randomSlogan();

			if (localStorage.getItem('agreement') && new Date().getTime() - localStorage.getItem('agreement') <= 604800000) {
				this.agreementState = true;
			}
		},

		beforeDestroy() {
			clearTimeout(this._sloganTimer);
			clearTimeout(this._timer);
		},

		methods: {
			randomSlogan() {
				!function loop() {
					let i = Math.floor(Math.random() * 5);
					if (this._lastSwitchSloganIndex == i) loop.call(this);
					else this._lastSwitchSloganIndex = this.switchSloganIndex = i;
				}.call(this);

				setTimeout(() => {
					let list = sloganList.filter(item => !this.slogan.find(temp => temp == item));
					this.$set(this.slogan, this.switchSloganIndex, list[Math.floor(Math.random() * list.length)]);
					this.switchSloganIndex = -1;
					this._sloganTimer = setTimeout(this.randomSlogan, 3000);
				}, 1000);
			},

			getSmscode() {
				if (this.countdown) return;
				if (!this.phone) {
					this.$message({
						message: '请输入手机号'
					});
					return;
				}
				this.request({
					url: '/login/verify/code',
					data: {
						client: 0,
						phone: this.phone
					},
					loading: true,
					success: () => {
						this.$message({
							message: '验证码已发送'
						});
						!function loop(s) {
							this.countdown = s;
							if (s == 0) return;
							this._timer = setTimeout(() => {
								loop.call(this, --s);
							}, 1000);
						}.call(this, 60);
					}
				});
			},

			login() {
				if (this.type == 1) {
					this.$refs.phoneLogin.submit({
						url: '/login/verify/code/check',
						breakWhenFail: true,
						rule: {
							phone: '请输入手机号',
							verify_code: '请输入短信验证码',
							agreement: [{
								type: 'function',
								message: '请阅读并同意《平台服务协议》和《隐私协议》',
								fun: () => {
									return this.agreementState
								}
							}]
						},
						dataFormatter: data => {
							data.client = 0;
							return data;
						},
						success: (data, res) => {
							if (!res.user_info.saas_id) {
								this._session = res.user_info.session;
								this.getFactory();
							} else {
								this.afterLogin(res);
							}
						},
						fail: (data, code) => {
							if (code != 8888) {
								clearTimeout(this._timer);
								this.countdown = 0;
							}
						}
					});
				} else {
					this.$refs.userLogin.submit({
						url: '/sys_user/login',
						breakWhenFail: true,
						rule: {
							saas_name: '请输入店铺/公司代码',
							user_name: '请输入用户名',
							user_pwd: '请输入密码',
							agreement: [{
								type: 'function',
								message: '请阅读并同意《平台服务协议》和《隐私协议》',
								fun: () => {
									return this.agreementState
								}
							}]
						},
						dataFormatter: data => {
							data.user_pwd = cryptoJs.MD5(data.user_pwd).toString();
							return data;
						},
						success: (data, res) => {
							this.afterLogin(res);
						}
					});
				}
			},

			getFactory() {
				this.request({
					url: '/sys_user/saas/list',
					data: {
						session: this._session
					},
					loading: true,
					success: data => {
						this.factoryList = data;
						this.$refs.factoryList.open();
					}
				});
			},
			
			factoryHandle(data) {
				this.request({
					url: '/sys_user/mobile/login',
					data: {
						session: this._session,
						saas_id: data.saas_id
					},
					loading: true,
					success: data => {
						this.afterLogin(data);
					}
				});
			},

			agreementHandle(type) {
				this.request({
					url: '/article/detail',
					data: {
						article_type: 0,
						id: type
					},
					loading: true,
					success: data => {
						this.$set(this.agreement, type, data.content);
						this.$refs['agreement' + type].open();
					}
				});
			},

			afterLogin(data) {
				localStorage.setItem('agreement', new Date().getTime());
				this.$store.dispatch('setLoginInfo', data);
				this.redirectTo(this.redirect);
				if (data.user_info.is_user_pwd != 1) {
					setTimeout(() => {
						this.$confirm({
							message: '当前登录的帐号还未设置密码，设置后即可使用帐号密码登录，是否立即设置？',
							buttonName: '立即设置',
							cancelButtonName: '稍后设置',
							resolve: () => {
								this.getSys().$refs.resetPsw.open();
							}
						});
					}, 500)
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.page {
		height: 100vh;
		overflow: hidden;
		background-color: #F4F8FB;
		background-image: url('~@/assets/image/login_bg.jpg');
		background-size: 100% auto;
		background-position: center;
		background-repeat: no-repeat;

		.logo {
			position: fixed;
			left: 65px;
			top: 40px;
			width: 220px;
		}

		.body {
			position: relative;
			box-sizing: border-box;
			width: 100%;
			max-width: 1600px;
			margin: 0 auto;

			.banner {
				position: absolute;
				left: 50px;
				top: 50%;
				box-sizing: border-box;
				width: 850px;
				height: 600px;
				padding-left: 40px;
				margin-top: 60px;
				transform: translate(0,-50%);

				.slogan {
					p {
						position: absolute;
						border-radius: 16px;
						padding: 0 20px;
						line-height: 32px;
						font-size: 16px;
						white-space: nowrap;
						color: #808ABB;
						background: linear-gradient(0deg, #E4E9FF, #FFFFFF);
						transition: opacity 1s ease;
						animation: slogan 6s infinite linear;
					
						@keyframes slogan {
							0% {
								transform: translate(0,0);
							}

							25% {
								transform: translate(0,-3px);
							}

							75% {
								transform: translate(0,3px);
							}

							100% {
								transform: translate(0,0);
							}
						}
						
						&:nth-child(1) {
							right: 50%;
							top: 230px;
							margin-right: 190px;
						}
						
						&:nth-child(2) {
							right: 50%;
							top: 320px;
							margin-right: 200px;
							animation-delay: -3s;
						}
						
						&:nth-child(3) {
							right: 50%;
							top: 410px;
							margin-right: 180px;
							animation-delay: -8s;
						}
						
						&:nth-child(4) {
							left: 50%;
							top: 370px;
							margin-left: 200px;
							animation-delay: -4s;
						}
						
						&:nth-child(5) {
							left: 50%;
							top: 460px;
							margin-left: 130px;
							animation-delay: -2s;
						}
					}
				}
			}

			.login {
				position: absolute;
				right: 50px;
				top: 50%;
				box-sizing: border-box;
				width: 550px;
				height: 480px;
				border-radius: 10px;
				padding: 44px 50px 0;
				background: #fff;
				box-shadow: 0 1px 6px 0 rgba(0,0,0,.08);
				transform: translate(0,-50%);
				
				.title {
					margin-bottom: 20px;
					font-size: 24px;
				}

				.tabs {
					margin-bottom: 20px;

					>>> ul {
						gap: 35px;

						li {
							padding: 0;
							font-size: 16px;
							color: #666;

							&.z-crt {
								font-size: 18px;
								color: var(--color-main);
							}
						}
					}
				}
				
				.form {
					gap: 0;
					padding: 0;
					
					.item {
						height: 44px;
						border-radius: 4px;
						margin-bottom: 18px;
						
						&-icon {
							margin: 0 10px 0 12px;
							font-size: 16px;
							color: #bbb;

							^[-1]:focus-within ^[-2..-1] {
								color: #000;
							}
						}

						.smscode {
							display: block;
							margin-top: 12px;
							margin-right: 16px;
							line-height: 20px;
							font-size: 12px;
							color: var(--color-main);

							&.z-dis {
								color: #999;
							}
						}
					}
				}
				
				.button {
					width: 100%;
					height: 46px !important;
					border-radius: 4px;
					margin-top: 24px;
					font-size: 18px;
				}
				
				.handle {
					a {
						font-size: 13px;
						color: #0060EF;
					}
				}

				.agreement {
					font-size: 12px;
					color: #999;
					
					a {
						&:hover {
							text-decoration: underline;
							color: var(--color-main);
						}
					}
				}
			}
		}

		.foot {
			box-sizing: border-box;
			max-width: 1600px;
			height: 76px;
			padding: 0 50px;
			margin: 0 auto;

			&-box {
				border-top: 1px solid #DEE7EE;
			}
			
			.copyright {
				line-height: 26px;
				font-size: 12px;
				color: #919FA9;

				img {
					display: inline-block;
					vertical-align: -4px;
					width: 16px;
					margin-right: .5em;
				}

				a {
					&:hover {
						text-decoration: underline;
					}
				}

				ins {
					margin: 0 1em;
				}
			}

			.link {
				position: relative;
				width: 34px;
				height: 34px;
				border: 1px solid #DEE7EE;
				border-radius: 50%;
				margin-left: 14px;
				font-size: 16px;
				color: #444;
				background: #fff;
				cursor: pointer;

				&:hover {
					border-color: var(--color-main);
					color: #fff;
					background: var(--color-main);
				}

				a {
					position: absolute;
					inset: 0;
				}
			}
		}
	}

	.factory-list {
		border-radius: 10px;
		padding: 0 30px 40px;
		background: #FFFFFF;

		dt {
			line-height: 100px;
			font-size: 24px;
			font-weight: bold;
			text-align: center;
		}

		dd {
			li {
				height: 60px;
				border-radius: 4px;
				padding: 0 22px;
				margin-bottom: 13px;
				color: #fff;
				background: #32373E;
				cursor: pointer;

				&:hover {
					background: var(--color-main);
				}

				.icon {
					margin-right: 16px;
					font-size: 20px;
				}
			}
		}
	}

	.agreement-content {
		padding: 20px 32px;
		line-height: 28px;
		font-size: 14px;
	}

	.custom-service {
		padding: 30px 0 18px;

		.icon {
			font-size: 48px;
			color: #00BB00;
		}

		h1 {
			margin-top: 12px;
			font-size: 22px;
		}

		h2 {
			width: 310px;
			margin-top: 10px;
			line-height: 20px;
			font-size: 13px;
			font-weight: normal;
			text-align: center;
			color: #666;
		}

		img {
			width: 130px;
			height: 130px;
			border: 5px solid #D9F2EC;
			border-radius: 6px;
			margin: 20px 0 9px;
		}

		p {
			font-size: 13px;
			color: #999;
		}

		.tel {
			gap: 10px;
			width: 340px;
			height: 50px;
			border-radius: 6px;
			margin-top: 16px;
			font-size: 22px;
			color: #fff;
			background: var(--color-main);
		}
	}

	.qrcode {
		padding: 40px 0;

		h1 {
			font-size: 22px;
		}

		img {
			width: 130px;
			height: 130px;
			border: 5px solid #D9F2EC;
			border-radius: 6px;
			margin: 30px 0 9px;
		}

		p {
			font-size: 13px;
			color: #999;
		}
	}
</style>
